import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import _extends from '@babel/runtime-corejs3/helpers/extends';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React from 'react';
import cx from 'classnames';
import find from 'lodash/find';
import { getMenuListId } from '../helpers';
const _excluded = ['children', 'className', 'isMulti', 'innerRef', 'selectProps', 'innerProps'];
function ownKeys(e, r) {
  const t = _Object$keys(e);
  if (_Object$getOwnPropertySymbols) {
    let o = _Object$getOwnPropertySymbols(e);
    r && (o = _filterInstanceProperty(o).call(o, r => {
      return _Object$getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (let r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(r => {
      _defineProperty(e, r, t[r]);
    }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(r => {
      _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
export var GenericSelectControlMenuList = function (_ref) {
  let _find;
  const {
    children
  } = _ref;
  const {
    className
  } = _ref;
  const {
    isMulti
  } = _ref;
  const {
    innerRef
  } = _ref;
  const {
    selectProps
  } = _ref;
  const {
    innerProps
  } = _ref;
  const other = _objectWithoutProperties(_ref, _excluded);
  const {
    menuIsOpen
  } = selectProps;
  const {
    genericSelectStyles
  } = selectProps;
  const {
    id
  } = selectProps;
  const {
    maxHeight
  } = other;
  const menuListClasses = cx({
    'menu-list': !0,
    'menu-list--is-multi': isMulti
  }, genericSelectStyles.menuList, className, 'mf-excluded');
  const activeOptionId = (_find = find(children, child => {
    let _child$props;
    return child == null || (_child$props = child.props) === null || void 0 === _child$props ? void 0 : _child$props.isFocused;
  })) === null || void 0 === _find ? void 0 : _find.key;
  return React.createElement('ul', _extends({
    id: getMenuListId(id),
    className: menuListClasses,
    ref: innerRef,
    role: 'listbox',
    'aria-labelledby': selectProps['aria-labelledby'],
    'aria-activedescendant': activeOptionId,
    'aria-expanded': menuIsOpen,
    tabIndex: '0'
  }, innerProps, {
    style: _objectSpread(_objectSpread({}, innerProps == null ? void 0 : innerProps.style), {}, {
      maxHeight: maxHeight
    })
  }), children);
};
GenericSelectControlMenuList.__docgenInfo = {
  description: '',
  methods: [],
  displayName: 'GenericSelectControlMenuList'
}, GenericSelectControlMenuList.__docgenInfo = {
  componentName: 'GenericSelectControlMenuList',
  packageName: '@jutro/components',
  description: '',
  displayName: 'GenericSelectControlMenuList',
  methods: [],
  actualName: 'GenericSelectControlMenuList'
};